
<div style="position: relative">
    <div class="incident-date" :class="dateColor" :style="'height:' + height + 'px'" v-if="showDate">
        {{ dateAsString (this.date) }}
    </div>

    <c-list-card
        :height      = "height"
        :edit        = "false"
        border-width = "pa-2"
        @selected    = "onClick(false)"
        @context     = "onContext"
        @site        = "onSite"
    >
        <template v-slot:title>
            <div class="card-title title-line v-flex">
                <div class="mr-1">
                    <c-tag :label="contract(item)" :active="item.liftmanagement && item.liftmanagement !== 0" background-color="primary"  />
                </div>
                <div>
                    <slot name = "hint"></slot>
                </div>
                <div>
                    {{ item.incidentId }} {{ item.typeName }}
                </div>
                <div>
                    <slot name = "date" />
                </div>
            </div>
            <v-spacer />
            <div class="text-right customer-name">
                {{ item.customerName }}
            </div>
            <slot name="tag" />
            <div style="margin-top: -2px;" :style="showDate ? 'margin-right: 12px;' : ''">
                <c-site-icon
                    v-if      = "site"
                    :site     = "site"
                    @selected = "onSite"
                />
            </div>
        </template>
        <template v-slot:body>
            <div class="card-subtitle v-flex">
                <div class="address-line">
                    {{ item.street }}, {{ item.zip }} {{ item.city }}

                </div>
                <v-spacer />
                <div class="primary--text" style="font-size: 13px; " :style="showDate ? 'margin-right: 14px;' : ''">{{ item.elevatorNo}}</div>
            </div>

            <slot name="comment" />
        </template>
    </c-list-card>

    <v-menu
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
    >
        <v-list>
            <v-list-item @click = "onClick(false)">
                <v-list-item-title>Gehe zum Ereignis</v-list-item-title>
            </v-list-item>
            <v-list-item @click = "onClick(true)">
                <v-list-item-title>Gehe zum Ereignis in neuen Fenster</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</div>
